export default {
  "content": "<path d=\"M19 10a5 5 0 100-10 5 5 0 000 10z\" fill=\"#C70A14\"/><path d=\"M18 7.51h-.06a.98.98 0 01-.77-.45l-1-1.51c-.3-.46-.18-1.08.28-1.39a.997.997 0 011.38.28l.27.41 2.14-2.5a.999.999 0 111.52 1.3l-3 3.51c-.19.22-.47.35-.76.35z\" fill=\"#F6F6F9\"/><path d=\"M12 5H1.25C.56 5 0 5.56 0 6.25v15.5C0 22.44.56 23 1.25 23h7.57c.69 0 1.25-.56 1.25-1.25v-11.5c0-.14.11-.25.25-.25h3.79A6.97 6.97 0 0112 5zM6.22 18H3.78c-.43 0-.78-.45-.78-1s.35-1 .78-1h2.44c.43 0 .78.45.78 1s-.35 1-.78 1zm0-6H3.78c-.43 0-.78-.45-.78-1s.35-1 .78-1h2.44c.43 0 .78.45.78 1s-.35 1-.78 1zM19 12v9.75c0 .69.56 1.25 1.25 1.25h.5c.69 0 1.25-.56 1.25-1.25V11.32c-.91.43-1.92.68-3 .68z\" fill=\"#C70A14\"/>",
  "attrs": {
    "width": "24",
    "height": "23",
    "viewBox": "0 0 24 23",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};